export default [
	// Definite articles:
	"az", "a",
	// Indefinite article:
	"egy",
	// Numbers 0 to 10, 100, 1000:
	"nulla", "egy", "kettő", "kettő", "három", "négy", "öt", "hat", "hét", "nyolc", "kilenc", "tíz", "száz", "ezer",
	// Conjunctions:
	"és", "se", "sem", "vagy", "de",
	// Adverbs:
	"aztán", "ezután", "azután", "majd", "ezek után", "nagyon", "kicsit", "nagy", "kevés", "sok", "sokan", "kevesen", "jól",
	// Demonstrative pronouns:
	"ez", "ezek", "az", "azok", "néhány", "aki", "ami",
	// Personal pronouns:
	"én", "mi", "ő", "ők", "engem", "nekem", "velem", "nálam", "hozzám", "tőlem", "rajtam", "rám", "rólam", "téged",
	"neked", "veled", "érted", "nálad", "hozzád", "tőled", "rólad", "őt", "neki", "vele", "érte", "nála", "hozzá", "tőle",
	"rajta", "rá", "róla", "minket", "nekünk", "velünk", "értünk", "nálunk", "hozzánk", "tőlünk", "rólunk", "titeket",
	"nektek", "veletek", "értetek", "nálatok", "hozzátok", "tőletek", "rajtatok", "rátok", "rólatok", "őket", "nekik",
	"velük", "értük", "bennük", "náluk", "hozzájuk", "tőlük", "rajtuk", "rájuk", "róluk",
	// Transition words:
	"azonban", "ám", "ha", "szerintem", "míg", "bár", "habár", "hát", "ha", "amennyiben", "mivel", "azonban", "amíg", "azért", "ezért",
	// Interrogatives:
	"mi", "mit", "miért", "meddig", "mikor", "hány", "mennyi", "ki", "kit", "merre", "hogy", "hogyan", "miként", "hol",
	"honnan", "hová", "mivel", "milyen",
	// Interjections:
	"ó", "óh", "jaj",
	// Colours:
	"kék", "zöld", "fekete", "sárga", "piros", "szürke",
	// Miscellaneous:
	"ne", "nem", "hát", "nos",
];
